import { createElement } from "@wordpress/element";
import { forwardRef } from "@wordpress/element";
import PropTypes from "prop-types";
import classNames from "classnames";
import ValidationIcon from "./validation-icon";
const CLASSNAME_MAP = {
  variant: {
    success: "nfd-validation-input--success",
    warning: "nfd-validation-input--warning",
    info: "nfd-validation-input--info",
    error: "nfd-validation-input--error"
  }
};

/**
 * @param {string} variant The variant to render.
 * @param {Object} [validation] The validation state.
 * @param {string} [className] The classname.
 * @returns {JSX.Element} The ValidationInput component.
 */
const ValidationInput = forwardRef(({
  as: Component,
  validation = {},
  className = "",
  ...props
}, ref) => {
  return createElement("div", {
    className: classNames("nfd-validation-input", (validation === null || validation === void 0 ? void 0 : validation.message) && CLASSNAME_MAP.variant[validation === null || validation === void 0 ? void 0 : validation.variant])
  }, createElement(Component, {
    ref: ref,
    ...props,
    className: classNames("nfd-validation-input__input", className)
  }), (validation === null || validation === void 0 ? void 0 : validation.message) && createElement(ValidationIcon, {
    variant: validation === null || validation === void 0 ? void 0 : validation.variant,
    className: "nfd-validation-input__icon"
  }));
});
ValidationInput.propTypes = {
  as: PropTypes.elementType.isRequired,
  validation: PropTypes.shape({
    variant: PropTypes.string,
    message: PropTypes.node
  }),
  className: PropTypes.string
};
export default ValidationInput;